import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import Role from "./Role";
import CustomLoader from "../static/CustomLoader";
import {
  MasterPage,
  MasterToolbar,
  MasterButton,
  MasterSearch,
  MasterGrid,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";

const RoleListing = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [density, setDensity] = useState("standard");
  const [addShow, setAddShow] = useState(false);
  const [editShow, setEditShow] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const columns = [
    {
      field: "code",
      headerName: "Code",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "role",
      headerName: "Role",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "active",
      headerName: "Active",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (params.row.active ? "Active" : "Inactive"),
    },
  ];

  useEffect(() => {
    fetchRoles();
  }, [refresh]);

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}role/distinct`, { headers });
      if (!response.data || response.data.cd === 1) {
        toast.warning("No Role data found.");
        setRows([]);
        setFilterData([]);
      } else {
        setRows(response.data);
        setFilterData(response.data);
      }
      setSelectedData([]);
      setRefresh(false);
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error("Failed to fetch roles.");
      setRows([]);
      setFilterData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearch(value);
    if (value) {
      const filtered = filterData.filter((row) =>
        Object.values(row).some((val) =>
          String(val).toLowerCase().includes(value),
        ),
      );
      setRows(filtered);
    } else {
      setRows(filterData);
    }
  };

  const addHandleShow = () => {
    setAddShow(true);
  };

  const addHandleClose = () => {
    setShowConfirm(true);
  };

  const editHandleShow = () => {
    if (selectedData.length !== 1) {
      toast.warning("Please select exactly one role to update");
      return;
    }
    setEditShow(true);
  };

  const editHandleClose = () => {
    setShowConfirm(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setAddShow(false);
    setEditShow(false);
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  return (
    <>
      <MasterPage>
        <MasterToolbar
          actions={
            <>
              <MasterButton
                variant="add"
                tooltip="Create new Role"
                onClick={addHandleShow}
                disabled={loading}
              >
                Add
              </MasterButton>
              <MasterButton
                variant="update"
                tooltip="Edit Selected Role"
                onClick={editHandleShow}
                disabled={loading}
              >
                Update
              </MasterButton>
            </>
          }
          search={
            <MasterSearch
              tooltip="Search by All"
              value={search}
              onChange={handleSearch}
              inputRef={(input) => input && input.focus()}
            />
          }
        />
        <MasterGrid
          density={density}
          onDensityChange={(newDensityString) => setDensity(newDensityString)}
          rows={rows}
          columns={columns}
          getRowId={(row) => row.code}
          onSelectionModelChange={(ids) => setSelectedData(ids)}
        />
      </MasterPage>

      {loading && <CustomLoader />}

      <MasterDialog open={addShow} onHide={addHandleClose} title="Add Role">
        <Role
          selectedId=""
          mode="A"
          onHide={addHandleClose}
          setRefresh={setRefresh}
          existingRoles={rows}
        />
      </MasterDialog>

      <MasterDialog open={editShow} onHide={editHandleClose} title="Edit Role">
        <Role
          selectedId={selectedData && selectedData[0]}
          mode="U"
          onHide={editHandleClose}
          setRefresh={setRefresh}
          existingRoles={rows}
        />
      </MasterDialog>

      <MasterConfirmDialog
        show={showConfirm}
        title="Close Confirmation"
        message="Are you sure you want to close this modal?"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </>
  );
};

export default RoleListing;
